import { createSelector } from 'reselect';

const DEFAULT_LABELS = ['High Priority', 'Medium Priority', 'Low Priority', 'Blocked'];

const getLabel = (labels, labelId) => labels.find(label => label.id === labelId);
export const makeGetLabel = () => createSelector(getLabel, labels => labels);

const getLabels = labels => labels
    .filter(label => label && !label.removed)
    .sort((l1, l2) => {
        const l1Index = l1.default ? DEFAULT_LABELS.indexOf(l1.name) : (l1.name || '').toLowerCase();
        const l2Index = l2.default ? DEFAULT_LABELS.indexOf(l2.name) : (l2.name || '').toLowerCase();

        if (l1Index > l2Index) return 1;
        if (l1Index < l2Index) return -1;

        return 0;
    });
export const makeGetLabels = () => createSelector(getLabels, labels => labels);
